// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import TitleCard from './TitleCard';

interface Props {
  title: string;
  extra?: React.ReactElement;
  children?: React.ReactElement | React.ReactElement[];
}
export default function CardView({ title, children, extra }: Props): React.ReactElement {
  return (
    <>
      <TitleCard title={title}>{children}</TitleCard>
      {extra}
    </>
  );
}
